import type { ComputedRef, InjectionKey, WritableComputedRef } from 'vue'

export const componentSizes = ['', 'default', 'small', 'large'] as const

export type ComponentSize = typeof componentSizes[number]

export const componentSizeMap = {
    large: 40,
    default: 32,
    small: 24,
} as const

export interface ElPaginationContext {
    currentPage?: WritableComputedRef<number>
    pageCount?: ComputedRef<number>
    disabled?: ComputedRef<boolean>
    changeEvent?: (val: number) => void
    handleSizeChange?: (val: number) => void
}

export const elPaginationKey: InjectionKey<ElPaginationContext> =
    Symbol('elPaginationKey')